"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockchainConfigFactory = void 0;
const blockchainConfigFactory = (params, connectorClasses, offlineConnectorFactories) => {
    const config = Object.assign(Object.assign({}, params), { wallets: [], offlineConnectors: [] });
    offlineConnectorFactories.forEach((factory) => {
        config.offlineConnectors.push(factory(config));
    });
    connectorClasses.forEach((connectorClass) => {
        const connector = new connectorClass(config);
        if (connector.isWallet) {
            return config.wallets.push(connector);
        }
        config.offlineConnectors.push(connector);
    });
    return config;
};
exports.blockchainConfigFactory = blockchainConfigFactory;
